module.exports = __webpack_public_path__ + "img/0Q3B2213_Foamcore_MockedUp.edd3b5c4.jpg";